import React, {createContext, useContext} from "react"

// This simple component replaces classic Notistack methods with custom parent-bound methods
// in order to have properly positioned snackbar alerts.
import {parentOrigin} from "../utils/parentOrigin"

const ErrorBoundaryContext = createContext<any>(null)
export const useErrorBoundary = () => useContext(ErrorBoundaryContext)

export default function ErrorBoundaryProvider(props: any) {

    const handleError = (error: string) => {
        let payload = JSON.stringify(["handleError", error])
        window.top?.postMessage(payload, parentOrigin)
    }

    const handleSuccess = (success: string) => {
        let payload = JSON.stringify(["handleSuccess", success])
        window.top?.postMessage(payload, parentOrigin)
    }

    const handleWarning = (success: string) => {
        let payload = JSON.stringify(["handleWarning", success])
        window.top?.postMessage(payload, parentOrigin)
    }

    const handleInfo = (success: string) => {
        let payload = JSON.stringify(["handleInfo", success])
        window.top?.postMessage(payload, parentOrigin)
    }

    return (
        <>
            <ErrorBoundaryContext.Provider
                value={{
                    useErrorBoundary,
                    handleInfo, handleWarning, handleError, handleSuccess
                }}
            >
                {props.children}
            </ErrorBoundaryContext.Provider>
        </>
    )
}